import React, { useRef } from "react";
import gql from "graphql-tag";
import GraphQlWrapper from "core/components/graphQlWrapper";
import Slider from "react-slick";
import { MDBRow, MDBCol, MDBBox, MDBTypography } from "mdbreact";
import { useMediaQuery } from "react-responsive";
import useSlickTabOrder from "../useSlickTabOrder";

const SLIDER_QUERY = gql`
  {
    slider(name: "Slider 3") {
      autoplay
      slide_animation
      slide_list
      slides {
        has_overlay
        length
        media
        product_media
        name
        online_video
        overlay_cta_label
        overlay_cta_link
        overlay_text
        overlay_title
        video
        product_description
        product_url
      }
    }
  }
`;

const Slides = (props) => {
  const sliderData = props && props.data && props.data.slider;
  let isMobile = useMediaQuery({ maxWidth: 768 });
  const sliderRef = useRef(null);

  useSlickTabOrder(sliderRef, sliderData);

  if (!sliderData) return null;

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: sliderData.autoplay,
    autoplaySpeed: 7000,
    speed: 2800,
    cssEase: "linear",
    slidesToShow: 1,
    variableWidth: false,
    draggable: true,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    easing: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          swipe: true,
          arrows: true,
        },
      },
    ],
  };

  return (
    <Slider
      {...sliderSettings}
      ref={sliderRef}
      className="home-banner-slider2"
    >
      {sliderData.slides.map((slide, index) => {
        return (
          <MDBRow key={index} className="content-wrapper">
            <MDBCol className="content-inner p-0">
              <MDBBox className="banner-image">
                <img
                  src={isMobile ? slide.media : slide.product_media}
                  alt={slide.name || "banner-image"}
                  className="img-fluid"
                />
              </MDBBox>
              <MDBRow className="content-main">
                <MDBCol lg="6" className="top-content">
                  {slide.product_description && (
                    <div className="product-description">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: slide.product_description,
                        }}
                      ></p>

                      <a href={slide.overlay_cta_link}>
                        {slide.overlay_cta_label}
                      </a>
                    </div>
                  )}
                </MDBCol>
                <MDBCol lg="6" className="bottom-content">
                  <MDBTypography
                    tag={slide.overlay_text ? "h1" : "div"}
                    className="slider-title"
                  >
                    {slide.overlay_text}
                  </MDBTypography>

                  {slide.overlay_title && (
                    <a
                      className="view-product-link"
                      href={slide.product_url}
                      rel="noreferrer noopener"
                      target={`${
                        slide?.product_url?.includes("https://www")
                          ? "_blank"
                          : ""
                      }`}
                    >
                      {slide.overlay_title}
                    </a>
                  )}
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        );
      })}
    </Slider>
  );
};

const BannerSectionQueryContainer = (props) => {
  return (
    <GraphQlWrapper
      query={SLIDER_QUERY}
      variables={{ id: "slider", name: "slider" }}
      saveQuery={true}
    >
      <Slides />
    </GraphQlWrapper>
  );
};

export default BannerSectionQueryContainer;
